"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _postmsgRpc = require("postmsg-rpc");

var mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

var checkIsMobile = function checkIsMobile() {
  return mobileRegex.test(navigator.userAgent);
};
/**
 *  Iframe services binds functions to make calls to parent window for controlling iframe visibility
 *  and authProvider calls. It also runs rpc server to receive and realay request to another service.
 */


var IframeService = /*#__PURE__*/function () {
  /**
   * Create IframeService
   */
  function IframeService() {
    (0, _classCallCheck2["default"])(this, IframeService);
    (0, _defineProperty2["default"])(this, "display", void 0);
    (0, _defineProperty2["default"])(this, "hide", void 0);
    (0, _defineProperty2["default"])(this, "authenticate", void 0);
    (0, _defineProperty2["default"])(this, "createLink", void 0);
    var postMessage = window.parent.postMessage.bind(window.parent);
    /**
     * Registers rpc call function for display and hiding iframe (Note: reverse of
     * idw rpc calls, this is rpc client, sending messages to parent window)
     */

    this.display = (0, _postmsgRpc.caller)('display', {
      postMessage: postMessage
    });
    this.hide = (0, _postmsgRpc.caller)('hide', {
      postMessage: postMessage
    });
    /**
     * Registers rpc call functions for handling external auth calls needed for IDW to parent window
     */

    this.authenticate = (0, _postmsgRpc.caller)('authenticate', {
      postMessage: postMessage
    });
    this.createLink = (0, _postmsgRpc.caller)('createLink', {
      postMessage: postMessage
    });
  }
  /**
   *  Start service, binds handler to start receiving incoming requests
   *
   * @param     {Function}    requestHandler    a function that will consume all rpc request from parent window (specifically didProvider calls)
   */


  (0, _createClass2["default"])(IframeService, [{
    key: "start",
    value: function start(requestHandler) {
      (0, _postmsgRpc.expose)('send', requestHandler, {
        postMessage: window.parent.postMessage.bind(window.parent)
      });
    }
    /**
     *  Authenticate Request to authProvider in parent window
     *
     * @param     {String}    message      authentication message
     * @param     {String}    accountId    external account ID handling authentication message
     * @return    {Promise<String>}        AuthSecret - 32 byte string
     */

  }, {
    key: "displayIframe",

    /**
     *  Tells parent window to display iframe
     */
    value: function () {
      var _displayIframe = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.display(checkIsMobile());

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function displayIframe() {
        return _displayIframe.apply(this, arguments);
      }

      return displayIframe;
    }()
    /**
     *  Tells parent window to hide iframe
     */

  }, {
    key: "hideIframe",
    value: function () {
      var _hideIframe = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var root;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                root = document.getElementById('root');
                if (root) root.innerHTML = "";
                _context2.next = 4;
                return this.hide();

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function hideIframe() {
        return _hideIframe.apply(this, arguments);
      }

      return hideIframe;
    }()
  }]);
  return IframeService;
}();

var _default = IframeService;
exports["default"] = _default;